


































































import {
  Component,
  Vue,
} from 'vue-property-decorator';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { faChevronRight } from '@fortawesome/free-solid-svg-icons/faChevronRight';
import { faChevronDown } from '@fortawesome/free-solid-svg-icons/faChevronDown';

import bCollapse from 'bootstrap-vue/es/components/collapse/collapse';
import bListGroup from 'bootstrap-vue/es/components/list-group/list-group';
import bListGroupItem from 'bootstrap-vue/es/components/list-group/list-group-item';
import bToggle from 'bootstrap-vue/es/directives/toggle/toggle';

import { Navigation } from '@/models';

const SideMenuItemProps = Vue.extend({
  props: {
    navigation: {
      type: Object as () => Navigation,
      required: true,
    },
    accordionId: {
      type: String,
      required: true,
    },
  },
});

@Component({
  components: {
    FontAwesomeIcon,
    bCollapse,
    bListGroup,
    bListGroupItem,
  },
  directives: {
    bToggle,
  },
})
export default class SideMenuItem extends SideMenuItemProps {
  public readonly faChevronRight = faChevronRight;
  public readonly faChevronDown = faChevronDown;

  get hasChildItems() {
    return !!this.navigation.children && this.navigation.children.length > 0;
  }

  public accordion(id: string) {
    return `side-menu-accordion-${id}`;
  }

  public hideChildNavigation() {
    // Close all accordion in child navigations.
    this.$root.$emit('bv::collapse::accordion', 0, this.accordion(this.navigation.id));
  }
}

